import * as PIXI from "pixi.js";
import { Assets } from "pixi.js";
import { bundlingUtils } from "./BundlingUtils";
import { SoundLoadConfig } from "./shared/UI/SoundManagerUtils";
import { GameAssets } from "src/shared/util/GameAssets";

import loadingAtlasUrl from "url:../assets/textures/atlas/loadingAtlas.json";
import loadingAtlasPngUrl from "url:../assets/textures/atlas/loadingAtlas.webp";
import gameAtlasUrl from "url:../assets/textures/atlas/gameAtlas.json";
import gameAtlasPngUrl from "url:../assets/textures/atlas/gameAtlas.webp";
import introBgUrl from "url:../assets/textures/introBg.jpg";
import coinAtlasUrl from "url:../assets/textures/coin/coin_atlas.json";
import coinAtlasPngUrl from "url:../assets/textures/coin/coin_atlas.png";
import mainBgUrl from "url:../assets/textures/mainBg.jpg";
import fsBgUrl from "url:../assets/textures/fsBg.jpg";
import uiAtlasJsonUrl from "url:../assets/textures/uiAtlas.json";
import uiAtlasImageUrl from "url:../assets/textures/uiAtlas.webp";

import winFontUrl from "url:../assets/fonts/winFont.xml";
import winFontPngUrl from "url:../assets/fonts/winFont.png";

// import fastButtonOnUrl from "url:../assets/UI/fastOn.png";
// import fastButtonOffUrl from "url:../assets/UI/fastOff.png";
// import spinButtonNewUrl from "url:../assets/UI/spinButton.png";
// import buyButtonNewUrl from "url:../assets/UI/buyButton.png";
// import betButtonNewUrl from "url:../assets/UI/betButton.png";
// import bottomBarNewUrl from "url:../assets/UI/bottomBar.png";
// import bottomBarPortraitUrl from "url:../assets/UI/bottomBarPortrait.png";
// import autoplayButtonUrl from "url:../assets/UI/autoplayButton.png";
// import amountBackgroundUrl from "url:../assets/UI/amountBackground.png";
// import stopButtonNewUrl from "url:../assets/UI/stopButton.png";
// import soundButtonOnUrl from "url:../assets/UI/soundOn.png";
// import soundButtonOffUrl from "url:../assets/UI/soundOff.png";
// import infoButtonUrl from "url:../assets/UI/info.png";

import winsJsonUrl from "url:../assets/spine/wins.json";
import winsAtlasUrl from "url:../assets/spine/wins.atlas";
import winsAtlasPngUrl from "url:../assets/spine/wins.webp";
import projectileJsonUrl from "url:../assets/spine/projectile.json";
import projectileAtlasUrl from "url:../assets/spine/projectile.atlas";
import projectileAtlasPngUrl from "url:../assets/spine/projectile.webp";
import panelCurtainsJsonUrl from "url:../assets/spine/panel_curtains.json";
import panelCurtainsAtlasUrl from "url:../assets/spine/panel_curtains.atlas";
import panelCurtainsAtlasPngUrl from "url:../assets/spine/panel_curtains.webp";
import h1JsonUrl from "url:../assets/spine/h1.json";
import h1AtlasUrl from "url:../assets/spine/h1.atlas";
import h1AtlasPngUrl from "url:../assets/spine/h1.webp";
import h2JsonUrl from "url:../assets/spine/h2.json";
import h2AtlasUrl from "url:../assets/spine/h2.atlas";
import h2AtlasPngURl from "url:../assets/spine/h2.webp";
import h3JsonUrl from "url:../assets/spine/h3.json";
import h3AtlasUrl from "url:../assets/spine/h3.atlas";
import h3AtlasPngUrl from "url:../assets/spine/h3.webp";
import h4JsonUrl from "url:../assets/spine/h4.json";
import h4AtlasUrl from "url:../assets/spine/h4.atlas";
import h4AtlasPngUrl from "url:../assets/spine/h4.webp";
import h5JsonUrl from "url:../assets/spine/h5.json";
import h5AtlasUrl from "url:../assets/spine/h5.atlas";
import h5AtlasPngUrl from "url:../assets/spine/h5.webp";
import lowJsonUrl from "url:../assets/spine/lows.json";
import lowAtlasUrl from "url:../assets/spine/lows.atlas";
import lowAtlasPngUrl from "url:../assets/spine/lows.webp";
import bonusJsonUrl from "url:../assets/spine/bonus.json";
import bonusAtlasUrl from "url:../assets/spine/bonus.atlas";
import bonusAtlasPngUrl from "url:../assets/spine/bonus.webp";
import wildJsonUrl from "url:../assets/spine/wild_mult.json";
import wildAtlasUrl from "url:../assets/spine/wild_mult.atlas";
import wildAtlasPngUrl from "url:../assets/spine/wild_mult.webp";
import scatterStepJsonUrl from "url:../assets/spine/mult_hole.json";
import scatterStepAtlasUrl from "url:../assets/spine/mult_hole.atlas";
import scatterStepAtlasPngUrl from "url:../assets/spine/mult_hole.webp";
import anticJsonUrl from "url:../assets/spine/antic.json";
import anticAtlasUrl from "url:../assets/spine/antic.atlas";
import anticAtlasPngUrl from "url:../assets/spine/antic.webp";
import curtainsJsonUrl from "url:../assets/spine/curtains.json";
import curtainsAtlasUrl from "url:../assets/spine/curtains.atlas";
import curtainsAtlasPngUrl from "url:../assets/spine/curtains.webp";
import counterJsonUrl from "url:../assets/spine/counter.json";
import counterAtlasUrl from "url:../assets/spine/counter.atlas";
import counterAtlasPngUrl from "url:../assets/spine/counter.webp";
import multiplierJsonUrl from "url:../assets/spine/multiplier.json";
import multiplierAtlasUrl from "url:../assets/spine/multiplier.atlas";
import multiplierAtlasPngUrl from "url:../assets/spine/multiplier.webp";
import paylinesJsonUrl from "url:../assets/spine/paylines.json";
import paylinesAtlasUrl from "url:../assets/spine/paylines.atlas";
import paylinesAtlasPngUrl from "url:../assets/spine/paylines.webp";

import coinLoopUrl from "url:../assets/audio/coinLoop.m4a";
import crowdChantingLoopUrl from "url:../assets/audio/crowdChantingLoop.m4a";
import musicBonusUrl from "url:../assets/audio/musicBonus.m4a";
import musicMainUrl from "url:../assets/audio/musicMain.m4a";
import startGameUrl from "url:../assets/audio/startGame.m4a";
import winBigUrl from "url:../assets/audio/winBig.m4a";
import winBigEndUrl from "url:../assets/audio/winBigEnd.m4a";
import winMegaUrl from "url:../assets/audio/winMega.m4a";
import winMegaEndUrl from "url:../assets/audio/winMegaEnd.m4a";
import winNormalUrl from "url:../assets/audio/winNormal.m4a";
import winNormalEndUrl from "url:../assets/audio/winNormalEnd.m4a";
import winSuperUrl from "url:../assets/audio/winSuper.m4a";
import winSuperEndUrl from "url:../assets/audio/winSuperEnd.m4a";
import winSmallUrl from "url:../assets/audio/winSmall.m4a";
import buttonClickUrl from "url:../assets/audio/buttonClick.m4a";
import paylineShowUrl from "url:../assets/audio/payLine.m4a";
import reelSpinLoopUrl from "url:../assets/audio/reelSpinLoop.m4a";
import reelStopUrl from "url:../assets/audio/reelStop.m4a";
import anticipationUrl from "url:../assets/audio/anticipation.m4a";
import upgradeTheMultiplierUrl from "url:../assets/audio/upgradeTheMultiplier.m4a";
import totalWinUrl from "url:../assets/audio/totalWin.m4a";
import swordHitUrl from "url:../assets/audio/swordHit.m4a";
import swordBattleUrl from "url:../assets/audio/swordBattle.m4a";
import wildBonusUrl from "url:../assets/audio/wildBonus.m4a";
import win5MoreSpinsUrl from "url:../assets/audio/win5MoreSpins.m4a";
import randomWildMovementUrl from "url:../assets/audio/randomWildMovement.m4a";
import lionBattleUrl from "url:../assets/audio/lionBattle.m4a";
import freeSpinCounterDecreaseUrl from "url:../assets/audio/freeSpinCounterDecrease.m4a";
import freeSpinPopupUrl from "url:../assets/audio/freeSpinPopup.m4a";
import collectBonusUrl from "url:../assets/audio/collectBonus.m4a";
import uiFontUrl from "url:../assets/fonts/Roboto_Condensed-Regular.ttf";
import textFontUrl from "url:../assets/fonts/GermaniaOne-Regular.ttf";

import wildSymbolUrl from "url:../assets/symbols/Wild.png";
import bonusSymbolUrl from "url:../assets/symbols/Bonus.png";
import gannicusSymbolUrl from "url:../assets/symbols/Gannicus.png";
import gladiatorSymbolUrl from "url:../assets/symbols/Gladiator.png";
import lionSymbolUrl from "url:../assets/symbols/Lion.png";
import weapon1SymbolUrl from "url:../assets/symbols/Weapon1.png";
import weapon2SymbolUrl from "url:../assets/symbols/Weapon2.png";
import aLetterSymbolUrl from "url:../assets/symbols/A.png";
import kLetterSymbolUrl from "url:../assets/symbols/K.png";
import jLetterSymbolUrl from "url:../assets/symbols/J.png";
import qLetterSymbolUrl from "url:../assets/symbols/Q.png";

import symbolsAtlasJsonUrl from "url:../assets/symbols/symbols.json";
import symbolsAtlasImgUrl from "url:../assets/symbols/symbols.webp";

import wildsDemoUrl from "url:../assets/UI/WildsDemonstration.webp";
import betDemoUrl from "url:../assets/UI/BetDemonstration.webp";
import betwaysDemoUrl from "url:../assets/UI/Betways.webp";

import { soundManager } from "./shared/UI/SoundManager";

// NOTE: The files that need manual processing must not be added to any bundle, and must be created and processed manually
// I.e. createSpineAtlas, createBitmapFont, createSpritesheet
class GameAssetManager {
  private static _instance: GameAssetManager;

  private _totalProgress = { textures: 0, skeletons: 0, audio: 0 };

  public static getInstance(): GameAssetManager {
    if (!this._instance) {
      this._instance = new GameAssetManager();
    }

    return this._instance;
  }

  public createGameAssetBundles(): void {
    console.log("Adding loading bundle...");

    // Loading assets
    Assets.addBundle("loading", {
      introBg: introBgUrl,
    });

    console.log("Loading bundle added successfully!");

    console.log("Adding textures bundle...");

    // Texture assets
    Assets.addBundle("textures", {
      mainBg: mainBgUrl,
      fsBg: fsBgUrl,

      wildsDemo: wildsDemoUrl,
      betDemo: betDemoUrl,
      betwaysDemo: betwaysDemoUrl,

      // fastButtonOn: fastButtonOnUrl,
      // fastButtonOff: fastButtonOffUrl,
      // spinButtonNew: spinButtonNewUrl,
      // buyButtonNew: buyButtonNewUrl,
      // betButtonNew: betButtonNewUrl,
      // bottomBarNew: bottomBarNewUrl,
      // bottomBarPortrait: bottomBarPortraitUrl,
      // autoplayButton: autoplayButtonUrl,
      // amountBackground: amountBackgroundUrl,
      // stopButtonNew: stopButtonNewUrl,
      // soundButtonOn: soundButtonOnUrl,
      // soundButtonOff: soundButtonOffUrl,
      // infoButton: infoButtonUrl,

      // wildSymbol: wildSymbolUrl,
      // bonusSymbol: bonusSymbolUrl,
      // gannicusSymbol: gannicusSymbolUrl,
      // gladiatorSymbol: gladiatorSymbolUrl,
      // lionSymbol: lionSymbolUrl,
      // weapon1Symbol: weapon1SymbolUrl,
      // weapon2Symbol: weapon2SymbolUrl,
      // aLetterSymbol: aLetterSymbolUrl,
      // kLetterSymbol: kLetterSymbolUrl,
      // jLetterSymbol: jLetterSymbolUrl,
      // qLetterSymbol: qLetterSymbolUrl,
    });

    console.log("Textures bundle added successfully!");

    console.log("Adding spines bundle...");

    // Spine assets
    Assets.addBundle("spines", {
      winsJson: winsJsonUrl,
      projectileJson: projectileJsonUrl,
      panelCurtainsJson: panelCurtainsJsonUrl,
      h1Json: h1JsonUrl,
      h2Json: h2JsonUrl,
      h3Json: h3JsonUrl,
      h4Json: h4JsonUrl,
      h5Json: h5JsonUrl,
      lowJson: lowJsonUrl,
      bonusJson: bonusJsonUrl,
      wildJson: wildJsonUrl,
      scatterStepJson: scatterStepJsonUrl,
      anticJson: anticJsonUrl,
      curtainsJson: curtainsJsonUrl,
      counterJson: counterJsonUrl,
      multiplierJson: multiplierJsonUrl,
      paylinesJson: paylinesJsonUrl,
    });

    console.log("Spines bundle added successfully!");

    console.log("Adding audio bundle...");

    // Audio assets
    Assets.addBundle("audio", {
      coinLoop: coinLoopUrl,
      crowdChantingLoop: crowdChantingLoopUrl,
      musicBonus: musicBonusUrl,
      musicMain: musicMainUrl,
      winBig: winBigUrl,
      winBigEnd: winBigEndUrl,
      winMega: winMegaUrl,
      winMegaEnd: winMegaEndUrl,
      winNormal: winNormalUrl,
      winNormalEnd: winNormalEndUrl,
      winSuper: winSuperUrl,
      winSuperEnd: winSuperEndUrl,
      winSmall: winSmallUrl,
      buttonClick: buttonClickUrl,
      paylineShow: paylineShowUrl,
      reelSpinLoop: reelSpinLoopUrl,
      reelStop: reelStopUrl,
      anticipation: anticipationUrl,
      upgradeTheMultiplier: upgradeTheMultiplierUrl,
      totalWin: totalWinUrl,
      wildBonus: wildBonusUrl,
      swordHit: swordHitUrl,
      swordBattle: swordBattleUrl,
      lionBattle: lionBattleUrl,
      win5MoreSpins: win5MoreSpinsUrl,
      randomWildMovement: randomWildMovementUrl,
      freeSpinCounterDecrease: freeSpinCounterDecreaseUrl,
      freeSpinPopup: freeSpinPopupUrl,
      collectBonus: collectBonusUrl,
    });

    console.log("Audio bundle added successfully!");
  }

  /**
   * Load assets required for the loading screen.
   */
  public async loadLoadingScreenAssets() {
    await soundManager.createSound({ url: startGameUrl, key: "startGame" });
    const loadingAssets = await Assets.loadBundle("loading");

    // Add the spritesheet to loading assets
    loadingAssets.loadingAtlas = await bundlingUtils.createSpritesheet(
      loadingAtlasUrl,
      loadingAtlasPngUrl,
    );

    GameAssets.loading = loadingAssets;
  }

  /**
   * Load custom fonts for the game.
   */
  public async loadFonts(): Promise<void> {
    const font = new FontFace("UIFont", `url(${uiFontUrl})`);
    const textFont = new FontFace("TextFont", `url(${textFontUrl})`);

    try {
      await font.load();
      await textFont.load();
      document.fonts.add(font);
      document.fonts.add(textFont);
    } catch (err) {
      console.error("Failed to load fonts:", err);
    }
  }

  /**
   * Load game assets and track loading progress.
   */
  public async loadGameAssets(
    progressCallback?: (progress: number) => void,
    completeCallback?: () => void,
  ) {
    let soundLoadingProgress: number = 0;
    let customAssetsProgress: number = 0;

    const updateProgress = () => {
      const combinedProgress =
        (this._totalProgress.textures +
          this._totalProgress.skeletons +
          this._totalProgress.audio +
          soundLoadingProgress +
          customAssetsProgress) /
        5;

      progressCallback?.(combinedProgress);
    };

    const textures = await Assets.loadBundle("textures", (progress) => {
      this._totalProgress.textures = progress;
      updateProgress();
    });

    const skeletons = await Assets.loadBundle("spines", (progress) => {
      this._totalProgress.skeletons = progress;
      updateProgress();
    });

    const audio = await Assets.loadBundle("audio", (progress) => {
      this._totalProgress.audio = progress;
      updateProgress();
    });

    await this._loadSounds((progress: number) => {
      soundLoadingProgress = progress;
      updateProgress();
    });

    await this._loadCustomGameAssets(
      textures,
      skeletons,
      (progress: number) => {
        customAssetsProgress = progress;
        updateProgress();
      },
    );

    // Register ALL spine assets in PIXI's cache
    Object.keys(skeletons).forEach((key) => {
      PIXI.Assets.cache.set(key, skeletons[key]);
    });

    GameAssets.textures = textures;
    GameAssets.skeletons = skeletons;
    GameAssets.audio = audio;

    completeCallback?.();
  }

  private async _loadCustomGameAssets(
    textures: any,
    skeletons: any,
    callback: (progress: number) => void,
  ): Promise<void> {
    const assetDefs: {
      key: string;
      createFunction: () => Promise<any>;
      bundle: any;
    }[] = [
      {
        key: "gameAtlas",
        createFunction: () =>
          bundlingUtils.createSpritesheet(gameAtlasUrl, gameAtlasPngUrl),
        bundle: textures,
      },
      {
        key: "symbolAtlas",
        createFunction: () =>
          bundlingUtils.createSpritesheet(
            symbolsAtlasJsonUrl,
            symbolsAtlasImgUrl,
          ),
        bundle: textures,
      },
      {
        key: "uiAtlas",
        createFunction: () =>
          bundlingUtils.createSpritesheet(uiAtlasJsonUrl, uiAtlasImageUrl),
        bundle: textures,
      },
      {
        key: "coinAtlas",
        createFunction: () =>
          bundlingUtils.createSpritesheet(coinAtlasUrl, coinAtlasPngUrl),
        bundle: textures,
      },
      {
        key: "winsAtlas",
        createFunction: () =>
          bundlingUtils.createSpineAtlas(winsAtlasUrl, winsAtlasPngUrl),
        bundle: skeletons,
      },
      {
        key: "projectileAtlas",
        createFunction: () =>
          bundlingUtils.createSpineAtlas(
            projectileAtlasUrl,
            projectileAtlasPngUrl,
          ),
        bundle: skeletons,
      },
      {
        key: "panelCurtainsAtlas",
        createFunction: () =>
          bundlingUtils.createSpineAtlas(
            panelCurtainsAtlasUrl,
            panelCurtainsAtlasPngUrl,
          ),
        bundle: skeletons,
      },
      {
        key: "h1Atlas",
        createFunction: () =>
          bundlingUtils.createSpineAtlas(h1AtlasUrl, h1AtlasPngUrl),
        bundle: skeletons,
      },
      {
        key: "h2Atlas",
        createFunction: () =>
          bundlingUtils.createSpineAtlas(h2AtlasUrl, h2AtlasPngURl),
        bundle: skeletons,
      },
      {
        key: "h3Atlas",
        createFunction: () =>
          bundlingUtils.createSpineAtlas(h3AtlasUrl, h3AtlasPngUrl),
        bundle: skeletons,
      },
      {
        key: "h4Atlas",
        createFunction: () =>
          bundlingUtils.createSpineAtlas(h4AtlasUrl, h4AtlasPngUrl),
        bundle: skeletons,
      },
      {
        key: "h5Atlas",
        createFunction: () =>
          bundlingUtils.createSpineAtlas(h5AtlasUrl, h5AtlasPngUrl),
        bundle: skeletons,
      },
      {
        key: "lowAtlas",
        createFunction: () =>
          bundlingUtils.createSpineAtlas(lowAtlasUrl, lowAtlasPngUrl),
        bundle: skeletons,
      },
      {
        key: "bonusAtlas",
        createFunction: () =>
          bundlingUtils.createSpineAtlas(bonusAtlasUrl, bonusAtlasPngUrl),
        bundle: skeletons,
      },
      {
        key: "wildAtlas",
        createFunction: () =>
          bundlingUtils.createSpineAtlas(wildAtlasUrl, wildAtlasPngUrl),
        bundle: skeletons,
      },
      {
        key: "anticAtlas",
        createFunction: () =>
          bundlingUtils.createSpineAtlas(anticAtlasUrl, anticAtlasPngUrl),
        bundle: skeletons,
      },
      {
        key: "scatterStepAtlas",
        createFunction: () =>
          bundlingUtils.createSpineAtlas(
            scatterStepAtlasUrl,
            scatterStepAtlasPngUrl,
          ),
        bundle: skeletons,
      },
      {
        key: "curtainsAtlas",
        createFunction: () =>
          bundlingUtils.createSpineAtlas(curtainsAtlasUrl, curtainsAtlasPngUrl),
        bundle: skeletons,
      },
      {
        key: "counterAtlas",
        createFunction: () =>
          bundlingUtils.createSpineAtlas(counterAtlasUrl, counterAtlasPngUrl),
        bundle: skeletons,
      },
      {
        key: "multiplierAtlas",
        createFunction: () =>
          bundlingUtils.createSpineAtlas(
            multiplierAtlasUrl,
            multiplierAtlasPngUrl,
          ),
        bundle: skeletons,
      },
      {
        key: "paylinesAtlas",
        createFunction: () =>
          bundlingUtils.createSpineAtlas(paylinesAtlasUrl, paylinesAtlasPngUrl),
        bundle: skeletons,
      },
      {
        key: "font",
        createFunction: () =>
          bundlingUtils.createBitmapFont(winFontUrl, winFontPngUrl, "WinFont"),
        bundle: null,
      },
    ];

    const total: number = assetDefs.length;
    let completed: number = 0;

    const wrappedPromises = assetDefs.map((data) =>
      data.createFunction().then((result: any) => {
        if (data.bundle) {
          data.bundle[data.key] = result;
        }
        completed++;
        callback(completed / total);
      }),
    );

    await Promise.all(wrappedPromises);
  }

  private async _loadSounds(
    callback: (progress: number) => void,
  ): Promise<void> {
    const soundDefs: SoundLoadConfig[] = [
      { url: crowdChantingLoopUrl, key: "crowdChantingLoop", loop: true },
      { url: musicBonusUrl, key: "musicBonus", loop: true, volume: 0.6 },
      { url: musicMainUrl, key: "musicMain", loop: true, volume: 0.6 },
      { url: winBigUrl, key: "winBig" },
      { url: winBigEndUrl, key: "winBigEnd" },
      { url: winMegaUrl, key: "winMega" },
      { url: winMegaEndUrl, key: "winMegaEnd" },
      { url: winNormalUrl, key: "winNormal" },
      { url: winNormalEndUrl, key: "winNormalEnd" },
      { url: winSuperUrl, key: "winSuper" },
      { url: winSuperEndUrl, key: "winSuperEnd" },
      { url: winSmallUrl, key: "winSmall" },
      { url: buttonClickUrl, key: "buttonClick" },
      { url: paylineShowUrl, key: "paylineShow" },
      { url: reelSpinLoopUrl, key: "reelSpinLoop", loop: true },
      { url: reelStopUrl, key: "reelStop", volume: 0.5 },
      { url: coinLoopUrl, key: "coinLoop", loop: true },
      { url: upgradeTheMultiplierUrl, key: "upgradeTheMultiplier" },
      { url: totalWinUrl, key: "totalWin" },
      { url: anticipationUrl, key: "anticipation" },
      { url: swordHitUrl, key: "swordHit" },
      { url: swordBattleUrl, key: "swordBattle" },
      { url: wildBonusUrl, key: "wildBonus" },
      // TODO: This plays even when the wild doesn't move
      { url: randomWildMovementUrl, key: "randomWildMovement" },
      { url: lionBattleUrl, key: "lionBattle" },
      { url: freeSpinCounterDecreaseUrl, key: "freeSpinCounterDecrease" },
      { url: freeSpinPopupUrl, key: "freeSpinPopup" },
      // TODO: This can not work since it is overlayed with the multiplier sound
      { url: win5MoreSpinsUrl, key: "win5MoreSpins" },
      { url: collectBonusUrl, key: "collectBonus" },
    ];

    const total: number = soundDefs.length;
    let completed: number = 0;

    const wrappedPromises = soundDefs.map((loadConfig) =>
      soundManager.createSound(loadConfig).then(() => {
        completed++;
        callback(completed / total);
      }),
    );

    await Promise.all(wrappedPromises);
  }
}

export const gameAssetManager = GameAssetManager.getInstance();
